import WebApi from "@/views/loyalty/shared/modules/web_api"

export class LoginEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_LOYALTY_URL}api/login/`
        this.webApi = new WebApi()
    }

    // get token
    async check () {
        return this.webApi.get(`${this.url}`)
    }

    async create_login (login) {
        const response = await this.webApi.post(`${this.url}`, login)
        if (!response.status_code) {
            return response
        } else {
            console.error(`Ошибка с кодом: ${response.status_code}`)
            return response
        }
    }

    async get_login (login) {
        const response = await this.webApi.put(`${this.url}`, login)
        console.log('response', response)
        if (response.status_code === 200) {
            return response.data
        } else {
            console.error(`Ошибка с кодом: ${response.status_code}`)
            return response.data
        }
    }
}
